import { render, staticRenderFns } from "./Abyssus.vue?vue&type=template&id=581a712a"
import script from "./Abyssus.vue?vue&type=script&lang=js"
export * from "./Abyssus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports